import React from 'react';
import Container from 'react-bootstrap/Container';
import Col from 'react-bootstrap/esm/Col';
import Row from 'react-bootstrap/esm/Row';
import Common from "../../../layouts/Common";
import Breadcrumb from 'react-bootstrap/Breadcrumb';

import minapp from '../../../assets/images/minapp.jpg';



const WorkshopMinistryEducation = () => {
return (
<Common>
   <section className='sub-page-banner newsr-bg'>
      <Container>
         <Row>
            <Col md={12} className='text-center sup-page-inner'>
            <h2>Newsroom</h2>
            <Breadcrumb className='text-center custom-breadcrumb'>
               <Breadcrumb.Item>Home</Breadcrumb.Item>
               <Breadcrumb.Item>Newsroom</Breadcrumb.Item>
            </Breadcrumb>
            </Col>
         </Row>
      </Container>
   </section>
   <Container className='mb-5'>
      <Row className='column-reverse2'>
         <Col md={8} data-aos="fade-right">
         <div className='about-company mt-70 left-0'>
            <h5>Workshop with Ministry of Education</h5>
            <span className='date-title'>Dated : 14 December, 2013</span>
            <p className='line-h'>
            অনুষ্ঠিত হয়ে গেল শিক্ষা মন্ত্রণালয় সংশ্লিষ্ট প্রতিষ্ঠানগুলোর জন্য মোবাইল এ্যাপ্লিকেশন আইডিয়া ইনভেনশন কর্মশালা
            </p>

            <p className='line-h'>
            আজ সকাল ৯টায়, নিউমার্কেটের ন্যাশনাল অথরিটি অব এডুকেশন ম্যানেজমেন্ট-এর কনফারেন্স হলে অনুষ্ঠিত হয়ে গেল শিক্ষা মন্ত্রণালয় সংশ্লিষ্ট প্রতিষ্ঠানগুলোর জন্য মোবাইল এ্যাপ্লিকেশন আইডিয়া ইনভেনশন কর্মশালা। “জাতীয় পর্যায়ে মোবাইল এ্যাপ্লিকেশন উন্নয়নে সচেতনতা ও দক্ষতা বৃদ্ধি কর্মসূচি” বাস্তবায়নের অংশ হিসেবে কর্মশালাটি আয়োজন করেন গণপ্রজাতন্ত্রী বাংলাদেশ সরকারের তথ্য ও যোগাযোগ প্রযুক্তি মন্ত্রণালয়। অনুষ্ঠানে সূচনা বক্তব্য রাখেন তথ্য ও যোগাযোগ প্রযুক্তি মন্ত্রণালয়ের অতিরিক্ত সচিব কামাল উদ্দিন আহমেদ। পুরো আইডিয়া সেশনটি পরিচালনা করেন একই মন্ত্রণালয়ের সহকারী সচিব মিয়া মোহাম্মাদ কেয়ামউদ্দিন। উপস্থিত ছিলেন ইএটিএল-এর প্রধান নির্বাহী ড. নিজাম উদ্দিন আহমেদ। এ কর্মশালায় শিক্ষা মন্ত্রণালয়ের অধীনে ন্যাশনাল অথরিটি অব এডুকেশন ম্যানেজমেন্ট, বিএএনবিইআইএস, এআইআইসিটি, বদরুন্নেসা কলেজ, যশোর শিক্ষা বোর্ড, প্রাথমিক শিক্ষা অধিদপ্তর, মাধ্যমিক ও উচ্চ শিক্ষা অধিদপ্তরসহ বিভিন্ন সরকারী-বেসরকারী প্রতিষ্ঠান থেকে ২১ জন আমন্ত্রিত অতিথি অংশগ্রহণ করেন।
            </p>

            <p className='line-h'>
            সূচনা বক্তব্যের পর; মোবাইল এ্যাপস্রে পরিচিতি, এর ব্যবহার এবং শিক্ষা মন্ত্রণালয়ের সঙ্গে সংশ্লিষ্ট প্রতিষ্ঠানগুলোর জন্য কী ধরনের মোবাইল এ্যাপস্ তৈরী হতে পারে সে বিষয়ে প্রাথমিক ধারণাসহ প্রস্তাবনা রাখেন ইএটিএল-এর কনসালটেন্ট ড. নাজমুস সাদাত। এরপর আমন্ত্রিত কর্মকর্তাগণ একে একে তাদের প্রস্তাবনা উপস্থাপন করেন। এ সেশনে দেশে শিক্ষা বিস্তারের লক্ষ্যে কাজ করে যাওয়া বিভিন্ন প্রতিষ্ঠানসমূহ গ্রাহকদের কাছে আরও সহজ এবং সুস্পষ্টভাবে তাদের সেবা নিশ্চিত করার বিভিন্ন মাধ্যম নিয়ে আলোচনা করেন। তথ্য ও প্রযুক্তি মন্ত্রণালয়ের সহকারী সচিব মিয়া মোহাম্মাদ কেয়ামউদ্দিন একে একে সবার উপস্থাপনা শোনেন এবং পুরো আইডিয়া সেশনটি পরিচালনা করেন।
            </p>

            <p className='line-h'>
            এই সকল উন্মুক্ত আইডিয়া থেকে নির্বাচিত আইডিয়াসমূহকে গ্রহণ করে পরবর্তীতে মোবাইল এ্যাপস নির্মাণ করা হবে এবং পূর্ণাঙ্গ আইডিয়া সমূহকে উন্মুক্ত একটি ওয়েব সাইটে আইডিয়া রিসোর্স হিসেবে প্রকাশ করা হবে। এই প্রকল্পের আওতায় এই সকল আইডিয়া নিয়ে একটি প্রকাশনাও তৈরি করা হবে
                </p>
         </div>
         </Col>
         <Col md={4} data-aos="fade-left">
         <img className='news-details' src={minapp} alt="com" />
         </Col>
      </Row>

   </Container>
</Common>
);
};
export default WorkshopMinistryEducation;